module.exports = __webpack_public_path__ + "static/img/bellinibliss_th.eb8be67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/bellinibliss_th.png
// module id = UKh1
// module chunks = 0